var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconXM(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.41 20l8.3-8.29a1 1 0 00-1.42-1.42L20 18.59l-8.29-8.3a1 1 0 00-1.42 1.42l8.3 8.29-8.3 8.29a1 1 0 000 1.42 1 1 0 001.42 0l8.29-8.3 8.29 8.3a1 1 0 001.42 0 1 1 0 000-1.42z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h40v40H0z"
  })));
}

export default SvgIconXM;